export const EXTERNAL_LINKS = {
  discord: 'https://discord.com/invite/dfJbMJXHrQ',
  x: 'https://x.com/atsumeapp',
  instagram: 'https://www.instagram.com/atsumeapp/',
  bluesky: 'https://bsky.app/profile/did:plc:5iq34uf57lhqdwneghvqkby5',
} as const
